// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProfileTwoToneSvg from "@fishx/icons-svg/es/asn/ProfileTwoTone";
import FishxIcon from '../components/FishxIcon';

var ProfileTwoTone = function ProfileTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ProfileTwoToneSvg
  }));
};

ProfileTwoTone.displayName = 'ProfileTwoTone';
export default React.forwardRef(ProfileTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ProfileTwoTone.js
// module id = 3854
// module chunks = 0